import { render, staticRenderFns } from "./Expressorder.vue?vue&type=template&id=721f8af8&"
import script from "./Expressorder.vue?vue&type=script&lang=js&"
export * from "./Expressorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports